import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "empty", "file", "remove"]

  pickViaInput() {
    this.fileTarget.click()
  }

  pick() {
    const file = this.fileTarget.files[0]
    if (!file) return

    if (this.hasRemoveTarget) this.removeTarget.checked = false
    const url = URL.createObjectURL(file)
    if (this.hasPreviewTarget) {
      this.previewTarget.src = url
      this.previewTarget.classList.remove("hidden")
    }
    if (this.hasEmptyTarget) this.emptyTarget.classList.add("hidden")
  }

  remove(event) {
    event.preventDefault()
    if (this.hasFileTarget) this.fileTarget.value = ""
    if (this.hasRemoveTarget) this.removeTarget.checked = true
    if (this.hasPreviewTarget) {
      this.previewTarget.src = ""
      this.previewTarget.classList.add("hidden")
    }
    if (this.hasEmptyTarget) this.emptyTarget.classList.remove("hidden")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("is-dragover")
    const file = event.dataTransfer?.files?.[0]
    if (!file || !this.hasFileTarget) return

    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.fileTarget.files = transfer.files
    this.pick()
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("is-dragover")
  }

  dragleave(event) {
    event.preventDefault()
    this.element.classList.remove("is-dragover")
  }
}
